'use client';

import type { CmsWorkspaceLaunchContext } from '@/cms/workspace/launch-context';
import dynamic from 'next/dynamic';
import type { WorkspaceRuntimeDialogCallbacks } from './workspace-1/contracts/dialog-callbacks';
import type { WorkspaceRuntimeActionCallbacks } from './workspace-1/contracts/dialog-callbacks';
import type { WorkspaceStudioRenderModel } from './workspace-1/contracts/server-model';
import { WorkspaceStudioSkeleton } from './workspace-1/shell/workspace-studio-skeleton';
import type { WorkspaceLoadErrorCopy } from './workspace-load-error';
import type { CmsWorkspaceLaunchDetail } from './workspace-session-controller';

type LazyClientLoadedWorkspaceHostProps = {
  errorCopy: WorkspaceLoadErrorCopy;
  initialLaunchDetail?: CmsWorkspaceLaunchDetail;
  launchContext?: CmsWorkspaceLaunchContext;
  locale: string;
  runtimeDialogCallbacks?: WorkspaceRuntimeDialogCallbacks;
  runtimeActionCallbacks?: WorkspaceRuntimeActionCallbacks;
  surface: WorkspaceStudioRenderModel['surface'];
};

const ClientLoadedWorkspaceHost = dynamic<LazyClientLoadedWorkspaceHostProps>(
  () =>
    import('./client-loaded-workspace-host').then(
      (module) => module.ClientLoadedWorkspaceHost
    ),
  {
    loading: () => <WorkspaceStudioSkeleton />,
    ssr: false,
  }
);

export function LazyClientLoadedWorkspaceHost(
  props: LazyClientLoadedWorkspaceHostProps
) {
  return <ClientLoadedWorkspaceHost {...props} />;
}
